import { motion } from "framer-motion";
import gallery_1 from "../../assets/images/event_1.jpg"
import gallery_2 from "../../assets/images/event_2.jpg"
import gallery_3 from "../../assets/images/event_3.jpg"
import gallery_4 from "../../assets/images/event_4.jpg"
import gallery_5 from "../../assets/images/event_5.jpg"
import gallery_6 from "../../assets/images/event_6.jpg"
import gallery_7 from "../../assets/images/event_7.jpg"
import gallery_8 from "../../assets/images/event_8.jpg"
import gallery_9 from "../../assets/images/evernt_here.jpg"
const galleryImages = [
    {
        id: 1,
        url: gallery_1,
        alt: "Event Snapshot 1",
    },
    {
        id: 2,
        url: gallery_2, alt: "Event Snapshot 2",
    },
    {
        id: 3,
        url: gallery_3, alt: "Event Snapshot 3",
    },
    {
        id: 4,
        url: gallery_4, alt: "Event Snapshot 4",
    },
    {
        id: 5,
        url: gallery_9, alt: "Event Snapshot 5",
    },
    {
        id: 6,
        url: gallery_6, alt: "Event Snapshot 6",
    },
    {
        id: 7,
        url: gallery_7, alt: "Event Snapshot 7",
    },
    {
        id: 8,
        url: gallery_8, alt: "Event Snapshot 8",
    },
    {
        id: 9,
        url: gallery_9, alt: "Event Snapshot 9",
    },
    {
        id: 10,
        url: gallery_5, alt: "Event Snapshot 10",
    },
    {
        id: 11,
        url: gallery_2, alt: "Event Snapshot 11",
    },
   
];
export default function EventGallery() {
    return (
        <section className="relative w-full overflow-hidden bg-[#ffffff] lg:py-24 md:py-16 py-10 text-slate-900">
            <div
                className="pointer-events-none absolute top-0 left-0 w-full h-full opacity-20 "
                style={{
                    background:
                        "linear-gradient(135deg, #62d4f7 0%, #5dc9f0 40%, #3579be 60%",
                }}
            />
            <div className="relative z-10 mx-auto flex flex-col items-center px-6 lg:px-12 3xl:w-4/5 xl:w-[90%]">
                <div className="mb-16 flex max-w-4xl flex-col items-center text-center md:mb-20">
                    <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        className="mb-4 inline-flex items-center gap-2 rounded-full  px-3.5 py-1.5 backdrop-blur-md"
                    >
                        <span className="text-[11px] font-bold uppercase tracking-[0.2em] px-6 lg:px-0 text-slate-700">
                            Our Gallery
                        </span>
                    </motion.div>
                    <motion.h2
                        initial={{ opacity: 0, y: 15 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.08 }}
                        className="font-display text-3xl sm:text-4xl md:text-5xl font-bold px-6 lg:px-0 tracking-tight text-slate-950 "
                    >
                        Relive every
                        {" "}
                        <span className="italic font-serif font-normal text-[#5dc9f0]">
                            unforgettable moment
                        </span>{" "}
                    </motion.h2>
                    <motion.p
                        initial={{ opacity: 0, y: 15 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.15 }}
                        className="mt-5 max-w-2xl text-base font-normal leading-relaxed px-6 lg:px-0 text-slate-600 sm:text-lg"
                    >
                        Events may be over, but the learning continues. Explore what you accomplished onsite and continue your journey with helpful resources.
                    </motion.p>
                </div>
                {/* Masonry Gallery */}
                <div className="sm:columns-2 gap-4 md:columns-4 md:gap-4">
                    {galleryImages.map((item) => (
                        <div
                            key={item.id}
                            className="mb-4 break-inside-avoid overflow-hidden rounded-2xl bg-[#EBEBEB] p-0.5"
                        >
                            <img
                                src={item.url}
                                alt={item.alt}
                                loading="lazy"
                                className="block h-auto w-full rounded-[14px] object-cover"
                            />
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
}
